import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "../assets/css/productGraid.css";
import "../assets/css/categoryList.css";
import "../assets/css/GridModal.css";
import ModalBoxPopup from "./ModalBoxPopup";
import GridListingData from "./GridListingData";
import BreadcrumbSecand from "../Component/Layout/BreadcrumbSecand";
import img001 from "../../src/assets/images/c1.jpg";
import img002 from "../../src/assets/images/c2.jpg";
import img003 from "../../src/assets/images/c3.jpg";
import img004 from "../../src/assets/images/c4.jpg";
import img005 from "../../src/assets/images/c5.jpg";

const Product = [img001, img002, img003, img004, img005];

function ProductGraid() {
  const [show, setShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  const handleShow = (index) => {
    setCurrentIndex(index);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? Product.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === Product.length - 1 ? 0 : prevIndex + 1
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const SkeletonCard = () => (
    <div className="box">
      <div className="boximgaes">
        <Skeleton height={200} />
      </div>
      <div className="box-title d-flex justify-content-between align-items-center mt-2">
        <Skeleton width={60} />
        <Skeleton circle height={20} width={20} />
      </div>
    </div>
  );

  return (
    <>
      <BreadcrumbSecand />
      <section className="Category-Graid mt-2">
        <div className="container">
          <div className="row row-cols-2 row-cols-xl-5 g-3">
            {loading
              ? Array.from({ length: 5 }).map((_, index) => (
                  <div className="col" key={index}>
                    <SkeletonCard />
                  </div>
                ))
              : Product.map((productUrl, index) => (
                  <div className="col" key={index}>
                    <div className="box">
                      <div
                        className="boximgaes"
                        onClick={() => handleShow(index)}
                      >
                        <img
                          src={productUrl}
                          alt={`Product ${index + 1}`}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                      <div className="box-title d-flex justify-content-between align-items-center mt-2">
                        <p>8000</p>
                        <Link to="#" className="text-yellow">
                          <i className="bi bi-heart"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
             </div>
         </div>
      </section>

      {!loading && (
        <GridListingData
          Modal={Modal}
          show={show}
          handleShow={handleShow}
          handleClose={handleClose}
          handlePrev={handlePrev}
          Button={Button}
          Product={Product}
          currentIndex={currentIndex}
          handleNext={handleNext}
          ModalBoxPopup={ModalBoxPopup}
          setCurrentIndex={setCurrentIndex}
        />
      )}
    </>
  );
}
export default ProductGraid;
